import { useFrame, useThree } from '@react-three/fiber';
import { useEffect, useState } from 'react';
import { useMount } from 'react-use';
import { addListener, invokeEvent } from 'shared-base';
import { setCamera } from '../../sagas/helpers/saga.camera';
import { cartesianToSpherical, sphericalToCartesian } from './Three.utils';

const DEFAULT_POS = { radius: 25, alpha: 40, beta: 35 };

export function useCameraPos() {
  const { camera } = useThree();
  setCamera(camera);

  useMount(() => {
    const { x, y, z } = sphericalToCartesian(
      DEFAULT_POS.radius,
      DEFAULT_POS.alpha,
      DEFAULT_POS.beta
    );
    camera.lookAt(0, 10, 0);
    camera.position.set(x, y, z);
  });

  useFrame(({ camera }) => {
    const { position } = camera;
    const { x, y, z } = position;
    const orb = cartesianToSpherical(x, y, z);
    invokeEvent('cameraPos', orb);
  });
}

export function useListener(eventName: string, callback: Callback) {
  useEffect(() => {
    const unlisten = addListener(eventName, callback);

    return () => {
      unlisten();
    };
  }, []);
}

export function useListenerData(eventName: string) {
  const [data, setData] = useState<Json>({});

  useEffect(() => {
    const unlisten = addListener(eventName, setData);

    return () => {
      unlisten();
    };
  }, []);

  return data;
}
